import { Space, Typography, Divider, Checkbox, Button, message, Collapse } from 'antd';
import { useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import LoaderLogoGibobs from '../../../components/LoaderLogoGIbobs';
import axios from 'axios';
import env from '../../../environment';
import { useSelector } from 'react-redux';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function OpenData() {
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);
	const [authorized, setAuthorized] = useState<boolean>(false);
	const { t } = useTranslation();
	const { operationId, owner } = useParams<any>();
	const userToken = useSelector((state: any) => state.auth.token);
	const navigate = useNavigate();

	const UploadPanelHeader = () => {
		return (
			<Space>
				<img
					src="/images/ticket-star.png"
					alt="ticket"
					style={{
						height: 24,
						width: 'auto',
						verticalAlign: 'middle',
						flexShrink: 0
					}}
				/>
				<div
					style={{
						display: 'flex',
						flexDirection: isMobileOnly ? 'column' : 'row',
						alignItems: isMobileOnly ? 'flex-start' : 'center',
						gap: isMobileOnly ? 0 : 8
					}}>
					<Text
						style={{
							fontSize: isMobileOnly ? 14 : 16,
							fontWeight: 700
						}}>
						{t('service.free')}
					</Text>
					<Text
						style={{
							fontSize: isMobileOnly ? 14 : 16,
							fontWeight: 500,
							textAlign: 'left'
						}}>
						{t('upload.manually')}
					</Text>
				</div>
			</Space>
		);
	};

	const handleRedirect = () => {
		setLoading(true);
		axios
			.post(
				`${env.api.url}/v1/mortgages/data/update/${operationId}`,
				{
					key: 'checkOpendata',
					participant: owner,
					value: authorized
				},
				{ headers: { Authorization: `Bearer ${userToken}` } }
			)
			.then(() => {
				axios
					.get(`${env.api.url}/docs/sabadell/session/BANKFLIP/${owner}/${operationId}`, {
						headers: { Authorization: `Bearer ${userToken}` }
					})
					.then((res) => {
						if (res.data.data.includes('error')) {
							setTimeout(() => {
								setLoading(false);
								setError(true);
							}, 3000);
						} else {
							setTimeout(() => {
								window.location.href = res.data.data;
							}, 3000);
						}
					})
					.catch((err) => {
						console.error('Se ha producido un error: ', err);
						message.error('Se ha producido un error');
					});
			});
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				marginTop: !isMobileOnly && 32,
				width: '100%'
			}}>
			{loading ? (
				<div style={{ marginTop: 32, maxWidth: isMobileOnly ? 300 : 600, textAlign: 'center' }}>
					<Text style={{ fontSize: 20, fontWeight: 600, color: '#212121' }}>
						{t('redirecting.gibobs')}
					</Text>
					<LoaderLogoGibobs />
				</div>
			) : (
				<div
					style={{
						margin: '24px auto',
						display: 'flex',
						alignItems: 'center',
						flexDirection: 'column',
						gap: 24,
						color: '#212121',
						maxWidth: isMobileOnly ? '90%' : 820
					}}>
					{!error ? (
						<>
							<Text style={{ fontSize: 16, fontWeight: 700, textAlign: 'center' }}>
								{t('save.time')}
							</Text>
							<Space style={{ textAlign: 'left' }}>
								<img
									src="/images/gibobs_logo.png"
									alt="gibobs"
									style={{ height: 40, width: 'auto' }}
								/>
								<Divider
									type="vertical"
									style={{ borderColor: '#424242', margin: 0, height: 40 }}
								/>
								<Text style={{ fontSize: isMobileOnly ? 12 : 14 }}>{t('get.documentedInfo')}</Text>
							</Space>
							<Collapse
								expandIcon={({ isActive }) =>
									isActive ? (
										<UpOutlined style={{ color: '#757575' }} />
									) : (
										<DownOutlined style={{ color: '#757575' }} />
									)
								}
								expandIconPosition="end"
								items={[
									{
										key: '1',
										label: <UploadPanelHeader />,
										children: (
											<Space direction="vertical" style={{ gap: 16 }}>
												<Text>{t('upload.twoEasyWays')}</Text>
												<Text>{t('upload.stepAttachManually')}</Text>
												<Text>{t('upload.stepAuthorizeThirdParty')}</Text>
											</Space>
										),
										className: 'automatic-doc-collapse'
									}
								]}
							/>
							<Checkbox onChange={() => setAuthorized(!authorized)} defaultChecked={authorized}>
								<Text style={{ fontSize: isMobileOnly ? 12 : 14 }}>
									{t('authorize.transferData')}
								</Text>
							</Checkbox>
						</>
					) : (
						<Space
							direction="vertical"
							size={'large'}
							style={{
								maxWidth: isMobileOnly ? 300 : 550,
								alignItems: 'center',
								textAlign: 'center'
							}}>
							<img
								src="/images/user-switch.png"
								alt="gibobs"
								style={{ height: 60, width: 60, marginTop: 24 }}
							/>
							<Text
								style={{
									fontSize: isMobileOnly ? 16 : 20,
									fontWeight: 600,
									color: '#E8717D'
								}}>
								{t('error.ocurred')}
							</Text>
						</Space>
					)}
					{!isMobileOnly && (
						<Space direction="vertical" style={{ textAlign: 'center' }}>
							<Button
								onClick={handleRedirect}
								disabled={!error && !authorized}
								className={'button-primari-gibobs'}
								style={{ paddingLeft: 24, paddingRight: 24, marginLeft: 8, width: 200 }}
								type="primary">
								{error ? t('try.again') : t('download.withGibobs')}
							</Button>
							<Button
								className="button-text"
								type="text"
								style={{ marginLeft: 6, color: '#004799' }}
								onClick={() => {
									navigate(`/operations/${operationId}/documents`);
								}}>
								{error ? t('doc.uploadManually') : t('authorize.manualUploadSelected')}
							</Button>
							<Space direction="vertical" style={{ width: 780, textAlign: 'left', marginTop: 16 }}>
								{!error && (
									<a
										href="https://www.gibobs.com/seguridad/?_gl=1*1maiyrz*_gcl_au*MTA1Nzk2MTk0MS4xNzU2MzcyMjQ2LjIxNDI2NTQzMDYuMTc1OTE1ODA1OS4xNzU5MTU4MDYw"
										target="_blank"
										style={{ fontWeight: 600, textDecoration: 'underline', color: '#212121' }}>
										{t('gibobs.learnAboutServices')}
									</a>
								)}
								<Text style={{ fontSize: 12, color: '#424242' }}>
									{error ? t('error.exists') : t('download.afterBankTitle6')}
								</Text>
							</Space>
						</Space>
					)}
					{isMobileOnly && (
						<div style={{ maxWidth: 300, textAlign: 'left' }}>
							<Space direction="vertical">
								{!error && (
									<a
										href="https://www.gibobs.com/seguridad/?_gl=1*1maiyrz*_gcl_au*MTA1Nzk2MTk0MS4xNzU2MzcyMjQ2LjIxNDI2NTQzMDYuMTc1OTE1ODA1OS4xNzU5MTU4MDYw"
										target="_blank"
										style={{ fontWeight: 600, textDecoration: 'underline', color: '#212121' }}>
										{t('gibobs.learnAboutServices')}
									</a>
								)}
								<Text style={{ fontSize: 12, color: '#757575' }}>
									{error ? t('error.exists') : t('download.afterBankTitle6')}
								</Text>
							</Space>
							<div
								style={{
									position: 'fixed',
									bottom: 0,
									left: 0,
									width: '100%',
									padding: '12px 16px',
									zIndex: 1000,
									display: 'flex',
									flexDirection: 'column',
									gap: '8px',
									background: 'white'
								}}>
								<Button
									className="button-primari-gibobs"
									type="primary"
									onClick={handleRedirect}
									disabled={!error && !authorized}>
									{error ? t('try.again') : t('viability.interest')}
								</Button>
								<Button
									className="button-text"
									type="text"
									style={{ color: '#004799' }}
									onClick={() => {
										navigate(`/operations/${operationId}/documents`);
									}}>
									{error ? t('doc.uploadManually') : t('authorize.manualUploadSelected')}
								</Button>
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
